<template>
  <div>
    <template v-if="selectedFlag">
      <shipblu-button size="small" :textButton="`${$t('Download')} (${selected.length})`" :iconStyle="{iconPosition:'left', LeftIconName: 'DownloadIcon', LeftIconLibrary: 'feather'}" @click="downloadShipments()" class="w-full"/>
    </template>
    <template v-else>
      <vx-tooltip position="bottom" color="warning" :text="`${$t('Please select order you want to download!')}`">
        <shipblu-button size="small" :textButton="$t('Download')" :iconStyle="{iconPosition:'left', LeftIconName: 'DownloadIcon', LeftIconLibrary: 'feather'}" :disabled="true" class="w-full"/>
      </vx-tooltip>
    </template>
  </div>
</template>

<script>
export default {
  props: ['selected', 'taskListInfoData'],
  data () {
    return {
      headerTitle: ['Tracking Number', 'Merchant Name', 'Customer', 'Phone Number', 'Zone', 'Address', 'No. Packages', 'Cash', 'Delivery Time', 'Fees on Delivery', 'Try & Buy', 'Status'],
      headerVal: ['tracking_number', 'merchant', 'customer', 'phone', 'customer_zone', 'customer_address', 'number_of_packages', 'cash_amount', 'delivered_date', 'fees_on_delivery', 'is_buy_and_try', 'status'],
      selectedFlag: false
    }
  },
  watch: {
    selected (val) {
      if (val.length !== 0) {
        this.selectedFlag = true
      } else {
        this.selectedFlag = false
      }
    }
  },
  methods: {
    downloadShipments () {
      import('@/vendor/Export2Excel').then(excel => {
        const list = this.selected
        const data = this.formatJson(this.headerVal, list)
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: `${new Date(this.taskListInfoData.created).toLocaleDateString('fr-CA')} - ${this.taskListInfoData.customer_agent.first_name} ${this.taskListInfoData.customer_agent.last_name}`,
          autoWidth: true
        })
      })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        switch (j) {
        case 'customer':
          return v[j].full_name ? v[j].full_name : 'N/A'
        case 'phone':
          return v.customer.phone ? v.customer.phone : 'N/A'
        case 'merchant':
          return v[j].name ? v[j].name : 'N/A'
        case 'customer_zone':
          return v.customer.address.zone.name ? v.customer.address.zone.name : 'N/A'
        case 'customer_address':
          return v.customer.address.line_1 ? v.customer.address.line_1 : 'N/A'
        case 'number_of_packages':
          return v[j] ? v[j] : 'N/A'
        case 'cash_amount':
          return v[j] ? v[j].toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 'N/A'
        case 'delivered_date':
          return v[j] ? `${new Date(v[j]).getHours()}:${ new Date(v[j]).getMinutes()}` : 'N/A'
        case 'fees_on_delivery':
          return v.feesOnDelivery ? v.feesOnDelivery.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 'N/A'
        case 'is_buy_and_try':
          return v.isBuyAndTry ? 'Yes' : 'No'
        case 'status':
          return (this.taskListInfoData.status === 'completed' || this.taskListInfoData.status === 'failed') ? v.operationsStatus : v[j]
        }
        return v[j]
      }))
    }
  }
}
</script>